import { Signal } from '@angular/core';
import { IdBased } from '@app/shared/types/models/shared/id-based.model';
import { UserRole } from '@app/shared/types/models/user-role/user.role';
import { User } from '@app/shared/types/models/user/user.model';
import { GroupUser } from './group-user.model';

/** Signal Forms model of the create group / edit group name dialogs. */
export interface CompanyGroupFormModel {
  name: string;
}

export interface CreateCompanyGroupDialogData {
  parentGroupId: string;
}

export interface EditCompanyGroupNameDialogData {
  group: Group;
  id: string;
}

export interface SelectUsersToCompanyGroupDialogData {
  preselectedUsers: User[];
  lockedUser: User;
  group: Group;
}

export interface SelectUsersAsProjectParticpantsDialogData {
  preselectedUsers: User[];
  lockedUser: User;
  group: Group;
}

export interface SelectUsersRolesTDialogData {
  preselectedRoles: UserRole[];
  userId: string;
}

export interface SelectAdminGroupDialogData {
  preselectedUser: User;
  group: Group;
  id: string;
  isProjectParticipantsView: boolean;
}

export class Group implements IdBased {
  public childrenCount: number;
  public id: string;
  public name: string;
  public companyId: string;
  public parentGroupId?: string;
  public users: Signal<GroupUser[]>;

  public constructor(data: Partial<Group>) {
    Object.assign(this, data);
  }
}
